import React from "react";
import ReactDOM from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import App from "./App";
import "@rainbow-me/rainbowkit/styles.css";
import { getDefaultWallets, RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { configureChains, createConfig, WagmiConfig } from "wagmi";
import { mainnet } from "wagmi/chains";
import { alchemyProvider } from "wagmi/providers/alchemy";
import { publicProvider } from "wagmi/providers/public";
import "@mantine/core/styles.css";
import "./index.css";

const { chains, publicClient } = configureChains(
  [mainnet],
  [alchemyProvider({ apiKey: "9C_BrYLf3uOsP51bBFWwNyWToX-bESih" }), publicProvider()]
);

const { connectors } = getDefaultWallets({
  appName: "hellionz",
  projectId: "1b654d25998c045bbca2398f3f0f88dd",
  chains
});

const wagmiConfig = createConfig({
  autoConnect: true,
  connectors,
  publicClient
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //<React.StrictMode>
  <WagmiConfig config={wagmiConfig}>
    <RainbowKitProvider chains={chains}>
      <MantineProvider>
        <App />
      </MantineProvider>
    </RainbowKitProvider>
  </WagmiConfig>
  //</React.StrictMode>
);
